import { render } from "./Select2.vue?vue&type=template&id=690ab726"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\germa\\dev\\nic_cli\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__